import { createRoute } from '@tanstack/react-router'
import { FnA } from '@/pages/FnA'
import { Route as rootRoute } from './__root'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/fna',
  component: FnA,
})
